<template>
  <div id="app">
    <Header />
    <Gallery />
  </div>
</template>

<script>
  import Header from "./components/Header";
  import Gallery from "./components/Gallery";

  export default {
    name: 'App',
    components: {
      Header,
      Gallery
    }
  }
</script>

<style lang="scss" src="@/assets/scss/main.scss"></style>